import styled, { css, useTheme } from 'styled-components';
import { border } from 'styled-system';

import { Box } from '@hivebrite/design-system/Box';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import EventCanceledLabel from 'hb-react/shared/apps/Events/components/EventCanceledLabel';
import EventCoverPicture from 'hb-react/shared/apps/Events/components/EventCoverPicture';
import EventPricingTag from 'hb-react/shared/apps/Events/components/EventPricingTag';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';

const EventHeader = (props) => {
  const theme = useTheme();
  const { event } = useEventContext();
  const breakpoint = useBreakpoint();

  return (
    <Box
      {...props}
      css={css`
        position: relative;
        flex-direction: column;
      `}
      height="100%"
    >
      <Box opacity={event.cancelled ? 0.4 : 1} flexGrow={1} height="100%">
        {breakpoint === 's' ? (
          <StaticEventCoverPicture src={event.cover_picture} />
        ) : (
          <EventCoverPicture
            height="100%"
            width="100%"
            coverPicture={event?.new_cover_picture?.original_url}
            borderTopLeftRadius={{
              _: 0,
              l: theme.themeVariables.globalBorderRadius,
            }}
          />
        )}
      </Box>
      <Box position="absolute" top={2} left={2}>
        {event.cancelled ? (
          <EventCanceledLabel event={event} />
        ) : (
          <EventPricingTag event={event} />
        )}
      </Box>
    </Box>
  );
};

export default EventHeader;

const StaticEventCoverPicture = styled.img.attrs(({ theme }) => ({
  borderTopLeftRadius: { _: 0, l: theme.themeVariables.globalBorderRadius },
}))`
  ${border}
  width: 100%;
  height: 100%;
`;
